export default "__VITE_ASSET__GXStU2Ol__"